import { useCallback, useEffect, useMemo } from "react";
import { useUser } from "@auth0/nextjs-auth0/client";
import { useAnalytics } from "@/contexts/AnalyticsContext";
import useSegmentTrack from "@/hooks/useSegmentTrack";

const useSignOut = () => {
  const { user } = useUser();
  const analytics = useAnalytics();
  const doSegmentTrack = useSegmentTrack();
  const authBroadcastChannel = useMemo(
    () => new BroadcastChannel("signOutBroadcastChannel"),
    [],
  );

  const signOut = useCallback(() => {
    try {
      authBroadcastChannel.postMessage({ type: "signOut" });
      analytics.reset();
      if (user) localStorage.removeItem(`user_${user.sub}`);
      if (process.env.NEXT_PUBLIC_AUTH0_LOGOUT) {
        window.location.href = process.env.NEXT_PUBLIC_AUTH0_LOGOUT;
      }
      doSegmentTrack("Signed Out Successfully");
    } catch (err) {
      console.error("Error during sign out:", err);
    }
  }, [authBroadcastChannel, analytics, user, doSegmentTrack]);

  useEffect(() => {
    const handleBroadcastMessage = (event: MessageEvent) => {
      if (
        event.data.type === "signOut" &&
        process.env.NEXT_PUBLIC_AUTH0_LOGOUT
      ) {
        window.location.href = process.env.NEXT_PUBLIC_AUTH0_LOGOUT;
      }
    };

    authBroadcastChannel.addEventListener("message", handleBroadcastMessage);

    return () => {
      authBroadcastChannel.removeEventListener(
        "message",
        handleBroadcastMessage,
      );
    };
  }, [authBroadcastChannel]);

  return { signOut };
};

export default useSignOut;
